import { Stack, Typography } from "@mui/material"
import { AuthoringAuthorNotesEntryAction } from "./authoring-author-notes-entry"

export function ChangeTitleRow({ taskTitle, displayPayload, original, tailored, entry }) {
    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle2" sx={{ flex: 1, fontWeight: 600 }}>
                {taskTitle}
            </Typography>
            <AuthoringAuthorNotesEntryAction.Slot
                payload={displayPayload}
                original={original}
                tailored={tailored}
                entry={entry}
            />
        </Stack>
    )
}
